import referenceData from '@/components/MeterManagement/ReferenceData/store';

export default {
  namespaced: true,
  state: {},
  modules: {
    referenceData,
  },
};